import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { simpleSelectors } from './basicState'
import { Deeplinking } from '../reducers/deeplinking'
import { isMobile, isPhablet } from '../utils/deviceUtils'

export const isCerberusChildSelector = createSelector(
  [simpleSelectors.pageContext],
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) =>
    pageContext.isCerberusChild
)

export const isDeeplinkableActionReadySelector = createSelector(
  [
    simpleSelectors.pageContext,
    simpleSelectors.deeplinking
  ],
  (
    pageContext: WpsRuntime.atv.wps.PageContextModelProps,
    deeplinking: Deeplinking
  ) =>
    // The deeplinking module is required for deeplinking action specifically on MShop.
    Boolean(pageContext.app !== 'MShop' || deeplinking.ready)
)

export const isIosMShopSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) =>
    Boolean(pageContext.app === 'MShop' && pageContext.os === 'IOS')
)

export const isMobileSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext?: WpsRuntime.atv.wps.PageContextModelProps) =>
    isMobile(pageContext)
)

export const isPhabletSelector = createSelector(
    simpleSelectors.pageContext,
    (pageContext?: WpsRuntime.atv.wps.PageContextModelProps) =>
      isPhablet(pageContext)
)

export const isMShopSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) =>
    pageContext.app === 'MShop'
)
